import { useState } from 'react';
import { FileWarning } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../../components/ui/sheet';
import ClaimNoteBody from '../../components/ClaimNoteBody';

export default function ClaimNoteSheetButton({ precheck }) {
  const [open, setOpen] = useState(false);
  if (!precheck || !precheck.issue_count) return null;
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="staff-app-claim-note-open"
        className="w-full h-11 rounded-lg border border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400 text-sm font-semibold flex items-center justify-center gap-2">
        <FileWarning className="w-4 h-4" /> Supplier claim note ({precheck.issue_count} issue{precheck.issue_count === 1 ? '' : 's'})
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="max-h-[92vh] overflow-y-auto rounded-t-2xl" data-testid="staff-app-claim-note-sheet">
          <SheetHeader className="text-left mb-3">
            <SheetTitle>Supplier claim note</SheetTitle>
            <SheetDescription>Edit if needed, then send it to the supplier.</SheetDescription>
          </SheetHeader>
          <ClaimNoteBody precheckId={precheck.precheck_id} />
        </SheetContent>
      </Sheet>
    </>
  );
}
